import { useState } from 'react';
import ApiService from '../../../service/ApiService';
import { apiPaths } from '../../../service/apiPaths';
import { IDocument } from './Document.props';
import { useNavigate } from 'react-router-dom';
import { formatDateToISODateString, limit, updateComponent, ViewType } from '../../../util/constant';

const useDocument = () => {
  const [selectedDocumentView, setSelectedDocumentView] = useState<string | null>(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(null);
  const [documentData, setDocumentData] = useState<IDocument[]>([]);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const navigate = useNavigate();

const handleDateFilter = async (fromDate: Date | null, toDate: Date | null) => {
  setLoading(true)
  try {
    let endpoint = ``;
      if (fromDate && toDate) {
        const formattedFromDate = formatDateToISODateString(fromDate);
        const formattedToDate = formatDateToISODateString(toDate);
        endpoint = `${apiPaths.getDocument}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&page=${page}&limit=${limit}`;
        if (search) {
          endpoint = `${apiPaths.getDocument}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&search=${search}&page=${page}&limit=${limit}`;
        }
      } else {
        endpoint = `${apiPaths.getDocument}?page=${page}&limit=${limit}`;
        if (search) {
          endpoint = `${apiPaths.getDocument}?search=${search}&page=${page}&limit=${limit}`;
        }
      }
    const result = await ApiService({
      method: 'GET',
      endpoint: endpoint,
    });
    setDocumentData(result);
    setTotalPage(result.totalPage)
  } catch (error) {
    console.error('Error fetching filtered data:', error);
  }
  finally{
    setLoading(false)
  }
};

  const handleEdit = (id: string) => {
    setSelectedDocumentId(id);
  };

  const handleAdd = () => {
    navigate('/addDocument')
  }
  const updateScreen = (type : ViewType ) => {
    updateComponent(type , setSelectedDocumentView ,setSelectedDocumentId)
  }
  return {
    selectedDocumentView,
    selectedDocumentId,
    documentData,
    handleAdd,
    handleEdit,
    handleDateFilter,
    updateScreen,
    loading,
    setSearch,
    search,
    setPage,
    page,
    totalPage,
  };
};

export default useDocument;